module.exports = __webpack_public_path__ + "img/job-special-risk.1e610675.svg";